import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Products from "./pages/products";
import AboutUs from "./pages/aboutus";
import Homepage from "./pages/homepage";
import SidebarLayout from "./SidebarLayout";
import Contactus from "./pages/Contactus";
import Submitted from "./pages/Submitted";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SidebarLayout><Homepage /></SidebarLayout>} />
        <Route path="/products" element={<SidebarLayout><Products /></SidebarLayout>} />
        <Route path="/aboutus" element={<SidebarLayout><AboutUs /></SidebarLayout>} />
        <Route path="/contact" element={<SidebarLayout><Contactus /></SidebarLayout>} />
        <Route path="/Submit" element={<SidebarLayout><Submitted /></SidebarLayout>} />
      </Routes>
    </Router>
  );
}

export default App;
